exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".demo-ruleForm[data-v-a9172d64]{margin:20px auto 0;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-a9172d64&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/activity/ActBase.vue
// module id = 609
// module chunks = 2